import { getLocalBaseURL, getIDPURL, getClientId } from './envVals';
import { buildAuthUrl, generateNonce } from './utils';

export const loginRedirect = (returnUrl: string) => {

    const rdm = generateNonce()
    const idpURL = getIDPURL();
    const clientId = getClientId();

    const state = btoa(JSON.stringify({ returnUrl, rdm }))
    window.location.href = buildAuthUrl(`${idpURL}/authorize`, {
        client_id: clientId,
        redirect_uri: `${getLocalBaseURL()}/auth/callback`,
        response_type: 'code',
        state,
        nonce: rdm,
        isInternal: 'true',
        clientType: 'supplier',
        scope: 'openid email profile profile_deepfetch',
    });
};